import http from '@/lib/request';

import { ElNotification } from 'element-plus';
async function getRemoteVersion() {
  const timestamp = new Date().getTime();
  const response = await http.get(`${window.location.origin}/?time=${timestamp}`);
  // 返回的是字符串，需要转换为 html
  const el = document.createElement('html');
  el.innerHTML = response;
  let newVersion = '';
  const metaList = el.querySelectorAll('meta');
  metaList.forEach((item) => {
    if (item.name === 'app-version') {
      newVersion = item.content;
    }
  });
  return newVersion;
}
export async function checkVersion() {
  const currentVersion = document.querySelector('meta[name="app-version"]')?.getAttribute('content') || '';
  const newVersion = await getRemoteVersion();
  if (newVersion && newVersion !== currentVersion) {
    showUpdateTip();
  }
}

export function showUpdateTip() {
  ElNotification({
    message: '<div style="cursor:pointer;">系统有新版本，点我刷新使用新版</div>',
    duration: 0,
    dangerouslyUseHTMLString: true,
    onClick: () => {
      window.location.reload();
    },
    type: 'warning',
    // message:
    //   '<div id="refresh-btn" style="cursor:pointer;padding:0 10px;line-height:32px;height:32px;background:#e6a23c;color:white;width:fit-content;border-radius:4px;">立即刷新</div>',
  });
}
